import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { dict } from "./translations";

const I18nContext = createContext(null);

const STORAGE_KEY = "tt.lang";

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "pt";
    return localStorage.getItem(STORAGE_KEY) || "pt";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem(STORAGE_KEY, lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const t = useCallback(
    (path) => {
      const keys = path.split(".");
      let cur = dict[lang];
      for (const k of keys) {
        if (cur && typeof cur === "object" && k in cur) {
          cur = cur[k];
        } else {
          return path;
        }
      }
      return cur;
    },
    [lang]
  );

  const toggle = useCallback(() => setLang((l) => (l === "pt" ? "en" : "pt")), []);

  return (
    <I18nContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useT() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useT must be used inside <I18nProvider>");
  return ctx;
}
